export const environment = {
  production: true,
  apiUrl: 'https://piyushaswani.com/backend/api'
};